import React from "react";

export default function TopBanner() {
  return (
    <div
      data-testid="top-banner"
      className="w-full bg-[#0A1228] text-[#F5F2EC] py-2.5 px-4 text-center border-b border-[#B8935A]/30"
    >
      <p className="text-[10px] md:text-[11px] tracking-[0.35em] uppercase font-sans-body">
        <span className="text-[#D4B47A]">·</span> Ingyenes konzultáció · Monor és Pest megye <span className="text-[#D4B47A]">·</span>
      </p>
    </div>
  );
}
